module.exports = __webpack_public_path__ + "img/hr-dark-mud-decal-20.8a10e394.png";